export default {
  getAuditLoggingByDate: (state) => (inputValue) => {
    return state.auditLoggings.filter(auditLogging => {
      var dataTimeResult = null
      var levelResult = null
      var detailResult = null
      if (auditLogging.dataTime !== null) {
        dataTimeResult = auditLogging.dataTime.match(inputValue)
      }
      if (auditLogging.level !== null) {
        levelResult = auditLogging.level.match(inputValue)
      }
      if (auditLogging.detail !== null) {
        detailResult = auditLogging.detail.match(inputValue)
      }
      if (dataTimeResult !== null || levelResult !== null || detailResult !== null) {
        var result = auditLogging.dataTime + auditLogging.level + auditLogging.detail
        return result.match(inputValue)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auditLoggingModules/getters.js